<template>
    <v-snackbar
        v-model="feedback.show"
        :timeout="feedback.duration"
        centered
        top
        elevation="20"
        :color="`${style.color} lighten-4`"
        class="pa-6 pt-0 mt-12 snackbar">
        <div class="center_snackbar_message" :class="`${style.text_color}--text text--darken-1`" v-html="feedback.message"></div>
    </v-snackbar>
</template>

<script>
    import { feedback } from './feedback'

    // THE ONLY TWO LOOKS FOR FEEDBACK ACROSS THE ADMIN
    const STYLES = {
        success: { color: 'light-green', text_color: 'secondary' },
        error: { color: 'accent', text_color: 'accent' }
    }

    /*  MOUNTED ONCE IN App.vue - TRIGGER IT FROM ANY COMPONENT WITH this.$feedback (see ./feedback.js) */
    export default {
        name: 'NoticeSnackbar',

        computed: {
            feedback () {
                return feedback.state
            },
            style () {
                return STYLES[this.feedback.type] || STYLES.success
            }
        }
    }
</script>

<style scoped>
    .snackbar {
        z-index: 2100;
    }

    .center_snackbar_message {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        font-size: 1rem;
        font-weight: 600;
        font-family: 'AvenirMedium';
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/noticeSnackbar.vue